import { Container } from '@/components/ui/container';
import { InfiniteMovingCards } from '@/components/ui/infinite-moving-cards';
import { motion } from 'framer-motion';
import { testimonials } from '@/data/testimonials';
import { Search, Workflow, HeartHandshake } from 'lucide-react';
import Image from 'next/image';

export default function LandingTestimonials(): JSX.Element {
	const icons = [Search, Workflow, HeartHandshake];

	return (
		<Container className="max-w-7xl relative">
			<div className="absolute inset-0 jupiter-gradient opacity-5" />

			<div className="absolute inset-0 overflow-hidden">
				<Image
					src="/images/testimonials/tech-pattern.png"
					alt=""
					fill
					className="object-cover opacity-10 select-none pointer-events-none"
					quality={50}
					priority={false}
					sizes="100vw"
				/>
			</div>

			<motion.div
				initial={{ opacity: 0, y: 20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8 }}
				className="text-center mb-12 relative z-10 pt-4"
			>
				<h2 className="text-3xl md:text-4xl font-bold mb-4">What Our Clients Say</h2>
				<p className="text-xl text-muted-foreground">
					Real results from the businesses we partner with
				</p>
			</motion.div>

			<motion.div
				initial={{ opacity: 0, y: 20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8, delay: 0.2 }}
				className="relative z-10"
			>
				<InfiniteMovingCards
					items={testimonials.map((testimonial, index) => ({
						title: testimonial.title,
						quote: testimonial.quote,
						name: testimonial.author,
						position: testimonial.position,
						company: testimonial.company,
						icon: icons[index],
					}))}
					direction="right"
					speed="slow"
					showConnectors
				/>
			</motion.div>
		</Container>
	);
}
